<h2>This is a test of getting types out of field mapping without calling <code>*ngIf</code> a billion times</h2>

<pre>{{ formPropertiesSignal() | json }}</pre>

<div class="json-preview-block">
    <div class="json-preview">
        <p>Form's value</p>
        <pre>{{ form.value | json }}</pre>
    </div>

    <div class="json-preview">
        <p>Form's value append stuff</p>
        <pre>{{ formValsAppendStuff() | json }}</pre>
    </div>

    <div class="json-preview">
        <p>Fields from install</p>
        <pre>{{ fieldsFrominstall | json }}</pre>
    </div>
</div>

<div class="json-preview-block">
    <div class="json-preview">
        <p>Input form's matching types by ID</p>
        <pre>{{ formTypesComputed() | json }}</pre>
    </div>
</div>

<div class="json-preview-block">
    <div id="computed-form">
        <p>computed form</p>
        <pre>{{ formPropertiesSignal() | json }}</pre>
    </div>

    <div id="actual-form">
        <p>actual form</p>
        <pre>
&#123;
  "value": {{ form.value | json }},
  "enabled": {{ form.enabled }},
  "status": {{ form.status }},
  "pristine": {{ form.pristine }},
  "valid": {{ form.valid }}
&#125;
        </pre>
    </div>
</div>
